import graphql__866647324dab936a6543 from "./__generated__/Calendar_section.graphql.js";import { useCallback, useMemo, useState } from "react";
import { graphql, useFragment } from "react-relay";
import { Calendar as RsuiteCalendar } from "rsuite";

import CalendarDayEventsPanel from "./CalendarDayEventsPanel";

const Calendar = props => {
  const section = useFragment(Calendar_section, props.section);
  const { resources } = section;

  const [selectedDate, setSelectedDate] = useState(null);

  const formatDateKey = useCallback(date => date?.toLocaleDateString(), []);

  const calendarResourcesByDate = useMemo(() => {
    if (!resources) return {};

    const resourcesByDate = {};

    resources.forEach(resource => {
      const startsAt = new Date(resource.startsAt);
      const endsAt = new Date(resource.endsAt || resource.startsAt);
      let loopDate = new Date(startsAt);

      while (loopDate <= endsAt) {
        const dateKey = formatDateKey(loopDate);

        if (!resourcesByDate[dateKey]) {
          resourcesByDate[dateKey] = [];
        }

        resourcesByDate[dateKey].push(resource);
        loopDate.setDate(loopDate.getDate() + 1);
      }
    });

    return resourcesByDate;
  }, [formatDateKey, resources]);

  const renderCalendarCell = useCallback(
    date => {
      const dateResources = calendarResourcesByDate[formatDateKey(date)] || [];
      if (dateResources.length === 0) return null;

      const colors = [...new Set(dateResources.map(resource => resource.color))];

      return (
        <div className="calendar-dots-container">
          {colors.map(color => (
            <div
              key={color}
              className="calendar-color-dot"
              style={{ backgroundColor: color }}
            />
          ))}
        </div>
      );
    },
    [calendarResourcesByDate, formatDateKey]
  );

  const handleSelectDate = useCallback(date => {
    setSelectedDate(date);
  }, []);

  const resetSelectedDate = useCallback(() => {
    setSelectedDate(null);
  }, []);

  const selectedDateEvents = useMemo(
    () => selectedDate && calendarResourcesByDate[formatDateKey(selectedDate)],
    [calendarResourcesByDate, formatDateKey, selectedDate]
  );

  return (
    <>
      <RsuiteCalendar
        compact
        bordered
        isoWeek
        renderCell={renderCalendarCell}
        onSelect={handleSelectDate}
        className="page-section-calendar"
      />

      {selectedDate && (
        <CalendarDayEventsPanel
          date={selectedDate}
          events={selectedDateEvents}
          onClose={resetSelectedDate}
        />
      )}
    </>
  );
};

const Calendar_section = graphql__866647324dab936a6543;

export default Calendar;
